// Vendor Dependencies
import '../vendor/jquery';
import 'popper.js/dist/popper';
import 'bootstrap';

import '../vendor/granim';

new Granim({
  element: '#canvas-interactive',
  direction: 'left-right',
  isPausedWhenNotInView: true,
  states: {
    'default-state': {
      gradients: [
        // ['#3a7bd5', '#3a6073'],
        // ['#43cea2', '#185a9d'],
        // ['#2193b0', '#6dd5ed'],
        // ['#30cfd0', '#330867'],
        // ['#36d1dc', '#5b86e5']

        ['#00c6fb', '#005bea'],
        ['#009efd', '#2af598'],
        ['#21d4fd', '#b721ff'],

        ['#005bea', '#00c6fb'],
        ['#2af598', '#009efd'],
        ['#b721ff', '#21d4fd']
      ]
    }
  }
});
